import BaseView from './base-view.js';
import BackboneSlider from '../utils/backbone.slider.js';
import { mixin } from '../utils/mixin.js';

class SliderView extends BaseView {
	constructor(options) {
		super(options);
	}

	/*
	// NOTE: USING THIS WILL OVERRIDE EVENTS IN SLIDER MIXIN.  ADD ADDITIONAL EVENTS IN postReinder
	events() {
		return {
			
		};
	}
	*/
	postInitialize() { return {}; }

	bindings() { return {}; }

	listeners() {
		this.listenTo(this.pubSub, "requestVideoModal", this.handleRequestVideoModal, this);
	}

	postRender(configObj) {
		var self = this;
		// initialize the scroller
		this.initSlider(configObj);

		return self;

	}

	/**
	 * Video Modal requests won't automatically end the swipe.  This is a manual way to end the swipe.
	 */
	handleRequestVideoModal() {
		// this.sli_toughObject.swipeLength has to be defined for sli_swipeEnd to work
		if (this.sli_touchObject.swipeLength === undefined) {
			this.sli_touchObject.swipeLength = 0;
		}
		// force swipe end
		this.sli_swipeEnd();
	}

	cleanup() {
		//clear additional listeners
	}

}

// Mixin SecondClass into SliderView
mixin(SliderView, BackboneSlider);

export default SliderView;